(function ($) {
  function ReadMore() {
    if ($(".readmore").length > 0) {
      let lang = $("html").attr("lang");
      let $moreLink = '<a class="morelink" href="#">Veja mais...</a>';
      let $lessLink = '<a class="lesslink" href="#">Veja menos</a>';

      if (lang === "en") {
        $moreLink = '<a class="morelink" href="#">Read more...</a>';
        $lessLink = '<a class="lesslink" href="#">Read less</a>';
      } else if (lang === "es") {
        $moreLink = '<a class="morelink" href="#">Ver más...</a>';
        $lessLink = '<a class="lesslink" href="#">Ver menos</a>';
      }

      $(".readmore").readmore({
        speed: 350,
        // collapsedHeight: 200,
        heightMargin: 16,
        moreLink: $moreLink,
        lessLink: $lessLink,
        embedCSS: false,
        startOpen: false,
        beforeToggle: function beforeToggle(trigger, element, expanded) {
          // console.log('before');
          // console.log('trigger: ', trigger);
          // console.log('element: ', element);
          // console.log('expanded: ', expanded);
          // console.log('expandedHeight: ',  element.data('expandedHeight'));
        },
        afterToggle: function afterToggle(trigger, element, expanded) {
          // console.log('after');
          // console.log(expanded);
        },
      });
    }
  }

  function Cards() {
    let $card = $(".paragraph--type--card");
    if ($card.find(".field--name-field-image-card").length > 0) {
      $card.one().each(function () {
        $(this)
          .find(".paragraph-title")
          .prependTo($(this).find(".field--name-field-image-card"));
      });
    }
  }

  $(function () {
    //Calling function after Page Load
    ReadMore();
    Cards();
  });
})(jQuery);
